import Helper from "./Helper";

class LinkHandler {
  constructor() {

    const links = Array.prototype.slice.call(document.querySelectorAll('.target-blank'));

    links.forEach(element => {
      if(element.classList.contains('ns-frontpage-tile')) {
        element.querySelector('.ns-frontpage-tile__link').setAttribute("target", "_blank");
      } else if(element.classList.contains('ns-frontpage-article-quote-teaser')) {
        element.querySelector('.ns-frontpage-article-quote-teaser__link').setAttribute("target", "_blank");
      } else if(element.classList.contains('ns-countup-container')) {
        element.querySelector('.ns-countup-button').setAttribute("target", "_blank");
      } else {
        element.setAttribute("target", "_blank");
      }
    });

  }
}

export default LinkHandler;
